<mat-form-field class="multi-select-filter" appearance="outline">
  <mat-label>{{ label() }}</mat-label>
  <mat-chip-grid #chipGrid>
    @for (selected of selectedOptions(); track selected.value) {
      <mat-chip-row (removed)="removeOption(selected)">
        {{ selected.label }}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>
  <input
    type="text"
    matInput
    [placeholder]="placeholder()"
    [(ngModel)]="searchText"
    (ngModelChange)="onSearchChange($event)"
    [matAutocomplete]="auto"
    [matChipInputFor]="chipGrid"
    [disabled]="isDisabled"
  />
  <mat-icon matSuffix class="dropdown-arrow">arrow_drop_down</mat-icon>
  
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onOptionSelected($event.option.value)"
  >
    @for (option of filteredOptions(); track option.value) {
      <mat-option [value]="option.value" [disabled]="option.disabled">
        {{ option.label }}
      </mat-option>
    }
    @if (filteredOptions().length === 0 && searchText()) {
      <mat-option disabled>No results found</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
